import { cx } from '@chakra-ui/utils';
import { useContext } from 'react';
import type {
  SingleValueProps as ReactSingleValueProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';

import { SelectContext } from '../SelectContext';
import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type SingleValueProps<OptionType extends OptionTypeBase> =
  ReactSingleValueProps<OptionType> & {
    innerProps: BoxProps;
  };

export const SingleValue = <OptionType extends OptionTypeBase>({
  children,
  innerProps,
}: SingleValueProps<OptionType>) => {
  const { singleValue: singleValueStyles } = useSelectStyles();

  const { hasAcceptedSuggestions } = useContext(SelectContext);

  return (
    <Box
      {...innerProps}
      className={cx(`${BASE_CLASS_NAME}__single-value`, innerProps?.className)}
      __css={{
        ...singleValueStyles,
        ...(hasAcceptedSuggestions ? { color: 'feature.suggestion' } : null),
      }}
    >
      {children}
    </Box>
  );
};
